import { isEmpty } from 'lodash';

// eslint-disable-next-line
export const emptyObjectOrAllValuesAreUndefined = (object: object): boolean =>
    Object.values(object).every((element) => isEmpty(element));
